module.exports = __webpack_public_path__ + "components/weather-icon/static/dayclear-20821f5b5526734edebb0168c3da359b.webp";